import {DoraResponse} from "@shared-interfaces/shared-workflow";
import { TranslateService } from '@ngx-translate/core';

export function getDate(): string {
  var today = new Date();
  var day = today.getDate();
  var month = today.getMonth() + 1;
  var year = today.getFullYear();
  var formattedDate =
    (day < 10 ? '0' + day : day) +
    '.' +
    (month < 10 ? '0' + month : month) +
    '.' +
    year;
  return formattedDate;
}

export function formatFilename(filename: string) {
  let nameWithoutExtension = filename.replace(/\.[^/.]+$/, "");
  let transformedString = nameWithoutExtension.replace(/[^0-9a-zA-Z_\- ]/g, '').replace(/\s/g, '_');

  return transformedString;
}

const getShortAnswer = (item: DoraResponse): string | undefined => {
  const raw = item.result?.['short_answer'] ?? item.shortAnswer;
  return typeof raw === 'string' ? raw : undefined;
};

export const allSameValue = (needle: string, haystack: DoraResponse[] | DoraResponse): boolean => {
  if (!haystack) {
    return false;
  }
  
  const haystackArray = Array.isArray(haystack) ? haystack : [haystack];
  
  if (haystackArray.length === 0) {
    return false;
  }
  
  return haystackArray.every(item => 
    getShortAnswer(item)?.toLowerCase() === needle?.toLowerCase()
  );
}

export const atLeastOneValue = (needle: string, haystack: DoraResponse[] | DoraResponse): boolean => {
  if (!haystack) {
    return false;
  }
  
  const haystackArray = Array.isArray(haystack) ? haystack : [haystack];
  
  if (haystackArray.length === 0) {
    return false;
  }
  
  return haystackArray.some(item => 
    getShortAnswer(item)?.toLowerCase() === needle?.toLowerCase()
  );
}


export const parseActiveStepPropToChartValues = (num: string,translate:TranslateService) => {
  const parsed = {
    cssClass: '' ,
    overall: 'Draft' ,
    yes: 0,
    no: 0,
    check: 0
  };
  if (!num.length) {
    return parsed;
  } else {
    switch (Number(num.substring(0, 1))) {
      case 2:
        parsed.overall = translate.instant('Yes');
        parsed.cssClass = 'yes';
        break;
      case 3:
        parsed.overall = translate.instant('No');
        parsed.cssClass = 'no';
        break;
      case 4:
        parsed.overall = translate.instant('ToBeChecked');
        parsed.cssClass = 'check';
        break;
    }
    parsed.yes = Number(num.substring(1, 3));
    parsed.no = Number(num.substring(3, 5));
    parsed.check = Number(num.substring(5, 7));
    return parsed;
  }
}

